// Date-only values use UTC consistently in the API and generation forms.
function licenseDateRange(months = 1, now = new Date()) {
  if (!Number.isSafeInteger(months) || months < 1)
    throw new Error(
      "License Validity must be a positive whole number of months",
    );
  const min = now.toISOString().slice(0, 10);
  const target = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + months, 1),
  );
  const lastDay = new Date(
    Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0),
  ).getUTCDate();
  target.setUTCDate(Math.min(now.getUTCDate(), lastDay));
  if (!Number.isFinite(target.getTime()) || target.getUTCFullYear() > 9999)
    throw new Error("License Validity exceeds the supported date range");
  return { min, max: target.toISOString().slice(0, 10) };
}

function validLicenseExpiry(date, range) {
  return (
    typeof date === "string" &&
    /^\d{4}-\d{2}-\d{2}$/.test(date) &&
    Number.isFinite(Date.parse(date)) &&
    new Date(date).toISOString().slice(0, 10) === date &&
    date >= range.min &&
    date <= range.max
  );
}
module.exports = { licenseDateRange, validLicenseExpiry };
